export const DEPLOYMENT_LABEL = import.meta.env.VITE_DEPLOY_ENV === 'prod'
  ? 'Production'
  : import.meta.env.VITE_DEPLOY_ENV === 'dev' || import.meta.env.DEV
    ? 'Development'
    : 'Preview';
